import React, {useState} from "react";
import PropTypes from "prop-types";
import {AButton} from "@cisco-sbg-ui/magna-react";
import {useTranslation} from "react-i18next";
import {useDispatch, useSelector} from "react-redux";
import {EntityDrawer} from "features/drawers";
import {postIncidentWorkflow} from "store/features/incidentResponseSlice";
import {selectEntitiesByType} from "store/selectors/incidentOverviewSelectors";
import {
  getWorkflowEntityData,
  getWorkflowEntityType,
  getWorkflowType,
  getWorkflowTypeName
} from "./responseUtils";

export default function SelectEntityDrawer({
  coaId,
  closeDrawer,
  coaTargetType,
  isDrawerOpen,
  workflowId
}) {
  const {t} = useTranslation();
  const dispatch = useDispatch();
  const entitiesByType = useSelector(selectEntitiesByType);
  const [selected, setSelected] = useState([]);

  const entityType = getWorkflowEntityType(coaTargetType);
  const data = getWorkflowEntityData(entitiesByType, coaTargetType);
  const name = getWorkflowTypeName(coaTargetType);

  const handleSubmit = () => {
    closeDrawer().then(() =>
      dispatch(
        postIncidentWorkflow({
          coaId,
          workflowId,
          type: getWorkflowType(coaTargetType),
          values: selected
        })
      )
    );
    setSelected([]);
  };

  const FooterButton = (
    <AButton
      medium
      disabled={selected.length === 0}
      onClick={() => handleSubmit()}>
      {t("response.execute")}
    </AButton>
  );

  return (
    <EntityDrawer
      {...{entityType}}
      count={data?.length || 0}
      data={data}
      entityListProps={{
        selectName: name,
        selectable: true,
        selected: selected,
        setSelected: setSelected,
        showPivotMenu: false
      }}
      footerContent={FooterButton}
      isOpen={isDrawerOpen}
      onClose={closeDrawer}
    />
  );
}

SelectEntityDrawer.propTypes = {
  /**
   * Function to close the drawer
   */
  closeDrawer: PropTypes.func,
  /**
   * State for current COA action type
   * @remark comes from task coa.open_c2_coa.target.type
   */
  coaTargetType: PropTypes.string,
  /**
   * Determines if the drawer is open or not
   */
  isDrawerOpen: PropTypes.bool
};
